var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.6144V15.1268C15.7501 15.3067 15.6781 15.4799 15.5487 15.6115C15.4192 15.7431 15.2419 15.8233 15.0525 15.8359C14.7247 15.8572 14.457 15.8686 14.25 15.8686C7.62225 15.8686 2.25 10.7791 2.25 4.50015C2.25 4.30405 2.26125 4.05039 2.2845 3.73989C2.29779 3.56044 2.38244 3.39245 2.52135 3.26981C2.66027 3.14717 2.84312 3.07902 3.033 3.0791H5.685C5.77803 3.07901 5.86777 3.11169 5.9368 3.17077C6.00582 3.22986 6.0492 3.31115 6.0585 3.39884C6.07575 3.56226 6.0915 3.69229 6.1065 3.79105C6.25555 4.77649 6.561 5.73493 7.0125 6.63387C7.08375 6.77597 7.03725 6.94579 6.90225 7.03673L5.28375 8.13237C6.27334 10.3168 8.11091 12.0577 10.4167 12.9952L11.5717 11.4647C11.619 11.4022 11.6878 11.3574 11.7664 11.338C11.8449 11.3187 11.9281 11.326 12.0015 11.3589C12.9503 11.7858 13.9617 12.0744 15.0015 12.215C15.1058 12.2293 15.243 12.2449 15.414 12.2605C15.5064 12.2695 15.592 12.3107 15.6543 12.376C15.7165 12.4414 15.7509 12.5263 15.7507 12.6144H15.75Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon_phone.b1cfc99eabcfff0c4ea0fe79bbfe0dac.svg";
export { ForwardRef as ReactComponent };